import type { RouteObject } from "react-router";

import { requireFeatureSwitch } from "../../routing/middleware.ts";

export const moduleSetRoute: RouteObject = {
  middleware: [requireFeatureSwitch("module-sets")],
  path: "module-sets/*",
  async lazy() {
    const { ModuleSetListPage } = await import("./ModuleSetListPage");
    return { Component: ModuleSetListPage };
  },
};
